module.exports = __webpack_public_path__ + "static/img/logo12.2fe78f34.jpg";